export default {
  personalProfile: "Persönliches Datenblatt",
  myAccount: "Mein Konto",
  back_to_my_account: "Zurück zu meinem Konto",
  already_active: "Ihr Konto wurde bereits aktiviert, bitte melden Sie sich an",
};
